export default "__VITE_ASSET__CWoT0y1X__"